import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

const INPUT_STYLE = {
  width: '100%',
  border: '1px solid #E9ECEF',
  borderRadius: '8px',
  padding: '8px 10px',
  fontSize: '14px',
  boxSizing: 'border-box',
  outline: 'none',
  fontFamily: 'inherit',
};

const LABEL_STYLE = {
  display: 'block',
  fontSize: '12px',
  color: '#6C757D',
  marginBottom: '4px',
};

export default function Login() {
  const { login, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro(null);
    try {
      const resultado = await login(email, senha);
      const perfil = resultado.usuario?.perfil;
      navigate(perfil === 'recepcionista' ? '/fila' : '/gerente');
    } catch (err) {
      const status = err.response?.status;
      if (status === 429) {
        setErro({ tipo: 'bloqueio', msg: 'Conta bloqueada. Tente em 15 minutos.' });
      } else {
        setErro({ tipo: 'credencial', msg: 'Credenciais inválidas.' });
      }
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#F8F9FA',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '16px',
      fontFamily: 'Inter, -apple-system, sans-serif',
    }}>
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <div style={{
          width: '48px',
          height: '48px',
          backgroundColor: '#E6F1FB',
          borderRadius: '12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '24px',
          margin: '0 auto 10px',
        }}>
          🩺
        </div>
        <p style={{ fontSize: '20px', fontWeight: 500, color: '#1A1A2E', margin: '0 0 4px' }}>
          COTI Ortopedia
        </p>
        <p style={{ fontSize: '13px', color: '#6C757D', margin: 0 }}>
          Central de atendimento
        </p>
      </div>

      <form
        onSubmit={handleSubmit}
        style={{
          backgroundColor: '#FFFFFF',
          borderRadius: '12px',
          border: '0.5px solid #E9ECEF',
          padding: '1.5rem',
          width: '100%',
          maxWidth: '360px',
        }}
      >
        <label style={LABEL_STYLE}>E-mail</label>
        <input
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
          autoComplete="email"
          style={INPUT_STYLE}
        />

        <div style={{ height: '14px' }} />

        <label style={LABEL_STYLE}>Senha</label>
        <input
          type="password"
          value={senha}
          onChange={e => setSenha(e.target.value)}
          required
          autoComplete="current-password"
          style={INPUT_STYLE}
        />

        <div style={{ height: '18px' }} />

        <button
          type="submit"
          disabled={loading}
          style={{
            width: '100%',
            padding: '9px',
            backgroundColor: loading ? '#ADB5BD' : '#185FA5',
            color: '#FFFFFF',
            border: 'none',
            borderRadius: '8px',
            fontSize: '14px',
            fontWeight: 500,
            cursor: loading ? 'not-allowed' : 'pointer',
            fontFamily: 'inherit',
          }}
        >
          {loading ? 'Entrando...' : 'Entrar'}
        </button>

        {erro && (
          <p style={{
            marginTop: '10px',
            fontSize: '13px',
            color: erro.tipo === 'bloqueio' ? '#854F0B' : '#991B1B',
            backgroundColor: erro.tipo === 'bloqueio' ? '#FAEEDA' : '#FDE8E8',
            borderRadius: '8px',
            padding: '8px 10px',
            margin: '10px 0 0',
          }}>
            {erro.msg}
          </p>
        )}
      </form>
    </div>
  );
}
